import { render, staticRenderFns } from "./Head-user.vue?vue&type=template&id=0f55bb88&scoped=true"
import script from "./Head-user.vue?vue&type=script&lang=js"
export * from "./Head-user.vue?vue&type=script&lang=js"
import style0 from "./Head-user.vue?vue&type=style&index=0&id=0f55bb88&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f55bb88",
  null
  
)

export default component.exports